/**
 * Primary front-end script.
 *
 * Primary JavaScript file. Any includes or anything imported should
 * be filtered through this file and eventually saved back into the
 * `/dist/js/app.js` file.
 *
 * @package   Classe7
 * @author    Matière Noire <contact@matierenoire.io>
 * @copyright 2018 Matière Noire
 * @license   https://www.gnu.org/licenses/gpl-2.0.html GPL-2.0-or-later
 * @link      https://github.com/matiere-noire/classe7
 */

import ScrollMagic from 'scrollmagic'
import cssVars from 'css-vars-ponyfill'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


gsap.registerPlugin(ScrollTrigger)

// Debuger scroll magic
//
// lancer la commande : yarn add scrollmagic-plugins --dev
//
// import { ScrollMagicPluginIndicator} from 'scrollmagic-plugins';
// ScrollMagicPluginIndicator(ScrollMagic);

/**
 * A ponyfill that provides client-side support for CSS custom properties (aka “CSS variables”) in legacy and modern browsers.
 * https://jhildenbiddle.github.io/css-vars-ponyfill/#/
 */
cssVars({})

/**
 * Sticky header
 */

// ScrollMagic controler

const initScrollMagic = () => {

    // Sous navigation
    const modules = document.querySelectorAll('.wp-block-classe7-modules-sticky')
    for (let module of modules) {

        new ScrollMagic.Scene({
            triggerElement: module,
            triggerHook: document.getElementById('sticky-header').offsetHeight / window.innerHeight,
            duration: module.nextElementSibling.offsetHeight
        })
            .setPin(module, {pushFollowers: false})
            .addTo(controller)
    }

    // Tour
    const tours = document.querySelectorAll('.wp-block-classe7-modules-container-style-2 .wp-block-classe7-modules.is-style-modules-2 .wp-block-group')
    for (let tour of tours) {

        const parent = tour.parentElement

        //descriptionLow permet de faire en sorte que les élements de liens ne sortent plus du sticky (pour cause de trop petite description par rapport a une première desc plus longue)
        let descriptionLow = parent.nextElementSibling.offsetHeight;
        const allTabsLink = tour.querySelectorAll('a')


        Array.prototype.slice.call(allTabsLink).forEach(function(accordion, index) {

            let descriptionId = accordion.getAttribute('href').substr(1)
            let description = document.getElementById(descriptionId);
            description.innerHTML="<div class='is-title-mobile'>"+accordion.innerHTML+"</div>" + description.innerHTML;

            if(description.hasAttribute("hidden")){
                description.removeAttribute("hidden");
                if(description.offsetHeight<descriptionLow){
                    descriptionLow = description.offsetHeight
                }
                if(window.innerWidth > 782){
                    description.setAttribute("hidden", "");
                }
            }

            window.addEventListener('resize', function() {
                if (window.innerWidth < 782) {
                    description.removeAttribute("hidden");
                }
                else {
                    description.setAttribute("hidden", "");
                }
                if(accordion==allTabsLink[0]){
                    accordion.click();
                }
            });
        });

        new ScrollMagic.Scene({
            triggerElement: tour,
            triggerHook: document.getElementById('sticky-header').offsetHeight / window.innerHeight,
            duration: descriptionLow - tour.firstChild.offsetHeight - 200 // 200 correspond au padding
        })
            .setPin(tour, {pushFollowers: false})
            .addTo(controller)
    }
}
const controller = new ScrollMagic.Controller()

window.onload = function() {
	const wpadminbar = document.getElementById('wpadminbar')
	const appSubheader = document.getElementById('app-subheader')

	let position = 0

	const stickyHeader = document.getElementById('sticky-header')

	if (appSubheader) {
		position += appSubheader.offsetHeight
	}

	if (wpadminbar) {
		position += wpadminbar.offsetHeight
	}

	stickyHeader.style.top = `${position}px`

	const scene = new ScrollMagic.Scene({ offset: position }).setPin(stickyHeader)

	// Si l'opacité est trop faible on la remonte quand on scroll les pages
	const opacityHeader = getComputedStyle(document.documentElement).getPropertyValue('--header-opacity')
	if (0.5 > parseFloat(opacityHeader)) {
		scene.setClassToggle(stickyHeader, 'min-opacity')
	}

	scene.addTo(controller)

	initScrollMagic()
}

/**
 * Scroll reveal
 */

const revealElements = document.querySelectorAll(
	'.is-style-circle-mask, ' +
    '.is-style-reveal-on-scroll, ' +
    'div[class^="wp-block-classe7-box"]:not([data-animation]) .wp-block-media-text__media, ' +
    '.wp-block-media-text__media:not([data-animation]), ' +
    '.classe7-icon-hover, ' +
    '.wp-block-embed, ' +
    '.wp-block-classe7-partenaires .wp-block-image, ' +
    '.wp-block-classe7-titre-chiffres-clefs .wp-block-column:not([data-animation]), ' +
    '.job-offers__service'
)
for (let i = 0; i < revealElements.length; i++) {
    const element = revealElements[i];
    if (element.matches('.wp-block-media-text__media')) {
        // On ne fait pas d'animation sur le bloc wp-block-media-text__media présent une box style 1 avec animation
        const parentBox = element.closest('div.wp-block-classe7-box-1[data-animation]');
        if (parentBox) {
            continue;
        }
    }
    gsap.from(element, {
        x: 0,
        y: 120,
        opacity: 0,
        scrollTrigger: {
            trigger: element,
            start: 'top 80%'
        }
    })
}

const animate = ( elem, scrollTrigger = true) => {
    const animation = JSON.parse(elem.dataset.animation)

    let x = 0
    let y = 0
    let scale = 1
    if (animation.direction === 'up') {
        x = 0
        y = -120
    } else if (animation.direction === 'down') {
        x = 0
        y = 120
    } else if (animation.direction === 'left') {
        x = -120
        y = 0
    } else if (animation.direction === 'right') {
        x = 120
        y = 0
    } else if (animation.direction === 'fade') {
        x = 0
        y = 0
    } else if (animation.direction === 'zoom') {
        x = 0
        y = 0
        scale = 2
    }

    let toggleActions = 'play none none none';

    if (animation.repeat) {
        toggleActions = 'restart none none none';
    }

    let animParam = {
        x: x,
        y: y,
        scale: scale,
        opacity: 0,
        duration: animation.duration,
        delay: animation.delay,

    }


    if (scrollTrigger) {
        animParam.scrollTrigger = {
            trigger: elem,
            start: 'top 80%',
            toggleActions: toggleActions
        }
    }

    gsap.from(elem, animParam)
}
const animateElements = document.querySelectorAll(
    '[data-animation]'
)


for (let i = 0; i < animateElements.length; i++) {
    animate(animateElements[i])
}

/**
 * Open menu connexion (secondary)
 */
const secondaryNavToggleButton = document.getElementById('secondary-nav-toggle')

if (secondaryNavToggleButton) {
	const secondaryMenu = document.querySelector('.app-subheader .menu--secondary')

	secondaryNavToggleButton.addEventListener('click', () => {
		secondaryMenu.classList.toggle('menu--secondary-open')
	})
}

/**
 * Open menu connexion (secondary)
 */
const secondaryNavToggleButtonResponsive = document.getElementById('secondary-nav-toggle-responsive')

if (secondaryNavToggleButtonResponsive) {
    const secondaryMenuResponsive = document.querySelector('.app-subheader-responsive .menu--secondary')

    secondaryNavToggleButtonResponsive.addEventListener('click', () => {
        secondaryMenuResponsive.classList.toggle('menu--secondary-open')
    })
}

/**
 * Open menu
 */
const primaryNavToggleButton = document.getElementById('primary-nav-toggle')

if (primaryNavToggleButton) {
	const primaryMenu = document.querySelector('.app-header .menu--primary')
	const appSubheaderResponsive = document.getElementById('app-subheader-responsive')
	const appSubheader = document.getElementById('app-subheader')
	const stickyHeader = document.getElementById('sticky-header')

    const openMenu = () => {

		primaryMenu.classList.toggle('open')
		if (appSubheader) {
			appSubheader.classList.toggle('open')
		}
		if (appSubheaderResponsive) {
			appSubheaderResponsive.classList.toggle('open')
		}
		if (stickyHeader && !primaryMenu.classList.contains('menu-jacqueline-4') && screen.width <= 950 ) {
			stickyHeader.classList.toggle('open')
		}

        // On ferme tous les sous menu ouvert
        const openSubMenu = primaryMenu.querySelectorAll('.mobile-sub-menu-open')
        if (openSubMenu) {
            openSubMenu.forEach(function(subMenu) {
                subMenu.classList.remove('mobile-sub-menu-open');
            })
        }
    }

	primaryNavToggleButton.addEventListener('click', openMenu)

    const primaryCloseNavButton = document.getElementById('primary-close-nav-toggle')

    if (primaryCloseNavButton) {
        primaryCloseNavButton.addEventListener('click', openMenu)
    }

    const backgroundNavToggleButton = document.getElementById('background-nav-toggle')

    if (backgroundNavToggleButton) {
        backgroundNavToggleButton.addEventListener('click', openMenu)
    }
}


const buttonLinks = document.querySelectorAll('.wp-block-button__link')

if (buttonLinks) {
    const primaryMenu = document.querySelector('.app-header')

    buttonLinks.forEach(function (buttonLink) {
        buttonLink.addEventListener('click', function(e) {
            if(buttonLink.getAttribute("href").startsWith('#')){
                document.location.href = buttonLink.getAttribute('href');
                window.scrollBy(0, -1 * primaryMenu.offsetHeight);

                e.preventDefault();
                return false;
            }
        })
    });
}

const menuItems = document.querySelectorAll('.app-header li.has-children')
Array.prototype.forEach.call(menuItems, function(el, i) {
	let timer

	el.addEventListener('mouseover', function(event) {
        Array.prototype.forEach.call(menuItems, function(el2, i) {
            el2.classList.remove('open')
        })
		el.classList.add('open')
		clearTimeout(timer)
	})
	el.addEventListener('mouseout', function(event) {
		timer = setTimeout(function(event) {
			el.classList.remove('open')
		}, 500)
	})

	el.querySelector('a.menu__link').addEventListener('click', function(event) {
		event.preventDefault()
		if (this.parentNode.classList.contains('has-children')) {
			this.parentNode.classList.add('mobile-sub-menu-open', 'open')
			this.parentNode.querySelector('a').setAttribute('aria-expanded', 'true')
		} else {
			this.parentNode.classList.remove('mobile-sub-menu-open', 'open')
			this.parentNode.querySelector('a').setAttribute('aria-expanded', 'false')
		}
	})
})

const primaryMenuButtonOpenSubMenu = document.querySelectorAll('.menu--primary .menu-item__open-sub-menu')

if (primaryMenuButtonOpenSubMenu) {
    primaryMenuButtonOpenSubMenu.forEach(function(button) {
        button.addEventListener('click', function(e) {
            button.closest('.mobile-sub-menu-open').classList.remove('mobile-sub-menu-open')
            e.preventDefault()
        })
    })
}

/**
 * Gestion du hover des actualité
 * @type {NodeListOf<Element>}
 */
const typePost = document.querySelectorAll('.entry--type-post')
if (typePost) {
	Array.prototype.forEach.call(typePost, function(el, i) {
		const link = el.querySelector('.entry__permalink')
		if (link){
			link.addEventListener('mouseenter', function() {
				el.classList.add('hover')
			})
			link.addEventListener('mouseleave', function() {
				el.classList.remove('hover')
			})
		}
	})
}
/**
 * A simple immediately-invoked function expression to kick-start
 * things and encapsulate our code.
 *
 * @since  1.0.0
 * @access public
 * @return void
 */
;(function() {
	// Block accordéons
	const allButton = document.querySelectorAll('.wp-block-classe7-accordion button')

	if (allButton) {
		const closeAllAccordions = () => {
			Array.prototype.slice.call(allButton).forEach(function(accordion) {
				const accContent = accordion.nextElementSibling
				accContent.setAttribute('hidden', '')
				accordion.setAttribute('aria-expanded', 'false')
			})
		}

        document.addEventListener('click', function(event) {
            let targetElement = event.target;
            // Check if the current toggle is expanded.
            if(targetElement.className=="classe7-accordion-title" || targetElement.className=="classe7-accordion-icon" ){
                let accordionElement = targetElement.closest("button");
                const isExpanded = 'true' === accordionElement.getAttribute('aria-expanded')

                const accContent = accordionElement.nextElementSibling

                if (!isExpanded) {
                    // On ferme tous les accordéons de la page quand on en ouvre un
                    closeAllAccordions()
                }

                // Set the expanded state on the triggering element
                accordionElement.setAttribute('aria-expanded', isExpanded ? 'false' : 'true')

                // Hide the accordion sections, using aria-controls to specify the desired section
                if (isExpanded) {
                    accContent.setAttribute('hidden', '')
                } else {
                    accContent.removeAttribute('hidden')
                }

                event.preventDefault()   
            }
        })

	}

	// Modules, tabulation, tour
	const allModules = document.querySelectorAll('.wp-block-classe7-modules, .wp-block-classe7-modules-sticky, .wp-block-classe7-tabulations, .wp-block-classe7-tours')

    if (allModules) {

        // Pour chaque block on gére le clique sur le liens
        for (let module of allModules) {

            // On commence par cacher tout les contenus si nécéssaire
            const allTabLink = module.querySelectorAll('a')
            const contentSelector = []
            Array.prototype.forEach.call(allTabLink, tabLink => {
                const href = tabLink.getAttribute('href');
                if(href){
                    contentSelector.push(href);
                }
            })

            const allTabContent = document.querySelectorAll(contentSelector.join())

            const closeAllTab = () => {
                Array.prototype.slice.call(allTabContent).forEach(function(moduleDescription) {
                    moduleDescription.setAttribute('hidden', '')
                })
                Array.prototype.slice.call(allTabLink).forEach(function(module) {
                    module.setAttribute('aria-expanded', 'false')
                    module.parentElement.parentElement.classList.remove('current')
                })
            }

            const openAllTab = () => {
                Array.prototype.slice.call(allTabLink).forEach(function(module) {

                    let descriptionId = module.getAttribute('href').substr(1)
                    let description = document.getElementById(descriptionId);
                    description.removeAttribute('hidden')
                    description.innerHTML="<div class='is-title-mobile'>"+module.innerHTML+"</div>" + description.innerHTML;
                })
            }

            let initialiseScrollMagicTabScene = null
            const initialiseTab = () => {
                closeAllTab()
                const hash = window.location.hash

                let currentTab = allTabContent[0]
                let currentTabLink = allTabLink[0]
                if (hash) {
                    const currentTabArray = Array.prototype.filter.call(allTabContent, tabContent => {
                        return `#${tabContent.getAttribute('id')}` === hash
                    })
                    if (0 < currentTabArray.length) {
                        currentTab = currentTabArray[0]
                    }

                    const currentTabLinkArray = Array.prototype.filter.call(allTabLink, tabLink => {
                        return tabLink.getAttribute('href') === hash
                    })
                    if (0 < currentTabLinkArray.length) {
                        currentTabLink = currentTabLinkArray[0]
                    }
                }

                currentTab.removeAttribute('hidden')
                currentTabLink.setAttribute('aria-expanded', 'true')
                currentTabLink.parentElement.parentElement.classList.add('current')

            }

            if(module.classList.contains("wp-block-classe7-modules-sticky")){

                if (0 < allTabContent.length && window.innerWidth >= 782) {
                    initialiseTab()
                } else if (0 < allTabContent.length) {
                    openAllTab()
                    module.style.display = 'none';
                }
            }
            else if (0 < allTabContent.length) {
                initialiseTab()
            }



            Array.prototype.slice.call(allTabLink).forEach(function(accordion, index) {
                accordion.addEventListener('click', function(event) {
                    const accContentId = accordion.getAttribute('href').substr(1)
                    const accContent = document.getElementById(accContentId)

                    closeAllTab()
                    accordion.setAttribute('aria-expanded', 'true')
                    accordion.parentElement.parentElement.classList.add('current')
                    accContent.removeAttribute('hidden')

                    const animateElements = accContent.querySelectorAll('[data-animation]')
                    for (let i = 0; i < animateElements.length; i++) {
                        animate(animateElements[i], false)
                    }

                    const parrentGroup = module.closest('.wp-block-group')
                    const isTour = parrentGroup && parrentGroup.classList.contains('wp-block-classe7-modules-container-style-2');
                    const isTabulation = module.classList.contains('wp-block-classe7-tabulations');
                    const isSticky = module.classList.contains('wp-block-classe7-modules-sticky');

                    if( isTour ){
                        accContent.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
                    }
                    else if(isSticky){
                        const stickyHeight = document.querySelector('.wp-block-classe7-modules-sticky').offsetHeight
                        const headerHeight = document.querySelector('#sticky-header').offsetHeight
                        const contentCoord = accContent.getBoundingClientRect().top

                        window.scrollTo({top: window.scrollY + contentCoord - stickyHeight - headerHeight, behavior: 'smooth'})
                    }
                    else if (isTabulation) {
                        accContent.scrollIntoViewIfNeeded({behavior: "smooth", block: "start", inline: "nearest"})
                    }
                    else{
                        const linkCoord = accordion.getBoundingClientRect()
                        const contentCoord = accContent.getBoundingClientRect()

                        window.scrollTo({top:  window.scrollY - ( ( linkCoord.bottom + 124 )  - contentCoord.top  ), left: 0, behavior: 'smooth'})
                    }

                    event.preventDefault()
                })
                accordion.addEventListener('mouseenter', function() {
                    accordion.parentElement.parentElement.classList.add('modules-hover')
                })
                accordion.addEventListener('mouseleave', function() {
                    accordion.parentElement.parentElement.classList.remove('modules-hover')
                })
            })
        }
    }

})()


// Block slider
jQuery(function($) {
	$('.wp-block-cb-carousel')
		.slick('slickSetOption', 'autoplaySpeed', 7000, true)
		.slick('slickPlay') //, { autoplay: true, autoplaySpeed: 7000 })
})

// Effet hover sur les box
const boxs = document.querySelectorAll('div[class^="wp-block-classe7-box"]')
if (boxs) {
	for (let box of boxs) {
		const boxLink = box.getElementsByTagName('a')
		if (boxLink.length > 0) {
			boxLink[0].addEventListener('mouseover', function (event){
				box.classList.add('box-hover')
			})
			boxLink[0].addEventListener('mouseout', function (event){
				box.classList.remove('box-hover')
			})
		}
	}
}

// Calcul hauteur quand il n'y a pas de bannière
document.addEventListener('DOMContentLoaded', () => {
	const blogHeader = document.getElementsByClassName('blog-header')[0];
	const bodyHasClass = document.body.classList.contains(
		'is-style-banner-full'
	   );
	const wpadminbar = document.getElementById('wpadminbar')
	const appHeader = document.getElementsByClassName('app-header')[0];

	let heightBanner = 0;

	if (wpadminbar) {
		heightBanner += wpadminbar.offsetHeight;
	}

	if (appHeader) {
		heightBanner += appHeader.offsetHeight;
	}

	if (bodyHasClass) {
		blogHeader.style.height = "calc(100vh - " + heightBanner + "px)";

	}
})

function getParentColumnMorphingBlocs(block) {
    var parentColumns = block.parentElement;
    while (parentColumns) {
        if (parentColumns.classList.contains("wp-block-columns")) {
            return parentColumns;
        }
        parentColumns = parentColumns.parentElement;
    }
}

const frontHeightMorphingBlocks = () => {

    const morphingBloc = document.getElementsByClassName('wp-block-classe7-morphingbloc');

    const frontHeightMorphingBlock = (block) => {
        let parentColumns = getParentColumnMorphingBlocs(block);
        if (parentColumns != null && parentColumns != undefined && parentColumns.hasAttribute("data-front-height")) {
            const content = block.querySelector('.classe7-morphingbloc__content');
            content.style.height = parentColumns.getAttribute("data-front-height") + 'px';
            block.style.height = parentColumns.getAttribute("data-front-height") + 'px';
        }
    }

    for (let item of morphingBloc) {

        // On attend que l'image soit loader
        const img = item.querySelector('img');
        if (img != undefined){
            if (img.complete) {
                frontHeightMorphingBlock(item)
            } else {
                img.addEventListener('load', () => frontHeightMorphingBlock(item))
            }
        }
    }
}

// Morphing bloc
const initMorphingBlocks = () => {
	const morphingBloc = document.getElementsByClassName('wp-block-classe7-morphingbloc');
	let Hcontainer = 0;

	// Logic pour un block
	const initMorphingBlock = (block) => {
		const front = block.querySelector('.classe7-morphingbloc__front');
		const back = block.querySelector('.classe7-morphingbloc__back');
		const content = block.querySelector('.classe7-morphingbloc__content');
		// On recupère la hauteur ouverte du bloc
		const openHeigth = block.offsetHeight;
		const frontHeigth = front.offsetHeight
			+ (parseInt( window.getComputedStyle(content).paddingTop ) * 2)
			+ (parseInt( window.getComputedStyle(content).borderWidth ) * 2) ;

        let parentColumns = getParentColumnMorphingBlocs(block);

        if ((parentColumns && parentColumns.hasAttribute("data-front-height") && frontHeigth > parseInt(parentColumns.getAttribute("data-front-height"))) || !parentColumns.hasAttribute("data-front-height")) {
            parentColumns.setAttribute("data-front-height", frontHeigth);
        }

		content.style.height = frontHeigth + 'px'
		block.style.height = frontHeigth + 'px'

		// On cache le contenu à caché
		block.classList.add('init');
		block.classList.add('close');

		const backHeigth = back.offsetHeight;

		block.addEventListener('mouseover', function (event) {
			block.classList.remove('close');
			front.style.bottom = backHeigth + 'px'
			content.style.height = openHeigth + 'px'
		})

		// On cache le bloc au mouseout
		block.addEventListener('mouseout', function (event) {
			block.classList.add('close');
			front.style.bottom = 0
            if (parentColumns && parentColumns.hasAttribute("data-front-height")) {
                content.style.height = parentColumns.getAttribute("data-front-height") + 'px';
            }
            else{
                content.style.height = frontHeigth + 'px';
            }
		})
	}

	for (let item of morphingBloc) {

		// On attend que l'image soit loader
		const img = item.querySelector('img');
        if (img != undefined){
            if (img.complete) {
                initMorphingBlock(item)
            } else {
                img.addEventListener('load', () => initMorphingBlock(item))
            }
        }
	}

    return new Promise((resolve,reject)=>{
            resolve();
    });
};


initMorphingBlocks();
setTimeout(function() {
    frontHeightMorphingBlocks()
}, 500);



document.addEventListener("DOMContentLoaded", function () {
    const modal = document.querySelector(".eb-modal-player");
    const stickyElement = document.querySelector(".wp-block-classe7-modules-sticky");

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                stickyElement.style.zIndex = "1"; // Quand le modal est visible
            } else {
                stickyElement.style.zIndex = "99"; // Remet la valeur par défaut
            }
        });
    }, { threshold: 0.1 });

    if (modal) {
        observer.observe(modal);
    }
});

